module.exports = __webpack_public_path__ + "562945a9d58a6ab96cdb6edfe9dbf687.png";